import { CheckboxOverrides } from "baseui/checkbox";

export const checkboxOverrides: CheckboxOverrides = {
  Checkmark: {
    style: ({ $checked, $theme }) => {
      const borderColor = $checked ? $theme.colors.positive : $theme.colors.mono600;
      return {
        borderTopRightRadius: $theme.borders.radius200,
        borderTopLeftRadius: $theme.borders.radius200,
        borderBottomRightRadius: $theme.borders.radius200,
        borderBottomLeftRadius: $theme.borders.radius200,
        backgroundColor: $checked ? $theme.colors.positive : null,
        borderTopColor: borderColor,
        borderRightColor: borderColor,
        borderBottomColor: borderColor,
        borderLeftColor: borderColor,
        borderTopWidth: "2px",
        borderRightWidth: "2px",
        borderBottomWidth: "2px",
        borderLeftWidth: "2px",
        borderTopStyle: "solid",
        borderRightStyle: "solid",
        borderBottomStyle: "solid",
        borderLeftStyle: "solid",
      };
    },
  },
  ToggleTrack: {
    style: ({ $checked, $theme }) => ({
      width: "40px",
      backgroundColor: $checked
        ? $theme.colors.positive
        : $theme.colors.mono600,
    }),
  },
  Toggle: {
    style: ({ $theme }) => ({
      backgroundColor: $theme.colors.white,
      boxShadow: `0px 2px 8px ${$theme.colors.mono600}`,
    }),
  },
};
